/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Barra from "./Barra/Barra";
import {BrowserRouter as Router, Route, Routes} from 'react-router';
import Seccion_Home from "./Secciones/Seccion_Home";
import Footer from "./Footer/Footer";
import {SECCIONES} from "../Constantes";
import Seccion_PQRSF from "./Secciones/Seccion_PQRSF";
import Seccion_Tratamiento_Datos from "./Secciones/Seccion_Tratamiento_Datos";
import Seccion_Educacion from "./Secciones/Seccion_Educacion";
import Seccion_Detalle_Oferta from "./Secciones/Seccion_Detalle_Oferta";

const Pagina = () => {


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Router>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 5}}>
                    <Barra/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                    <Routes>
                        <Route path={"*"} element={<Seccion_Home/>}/>
                        <Route path={"/Home"} element={<Seccion_Home/>}/>
                        <Route path={"/" + SECCIONES[3]} element={<Seccion_PQRSF/>}/>
                        <Route path={"/Tratamiento"} element={<Seccion_Tratamiento_Datos/>}/>
                        <Route path={"/" + SECCIONES[1]} element={<Seccion_Educacion/>}/>
                        <Route path={"/DetalleOferta/:nombre"} element={<Seccion_Detalle_Oferta/>}/>
                    </Routes>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Footer/>
                </Grid>


            </Router>

        </Grid>
    )

}
export default Pagina